import React, { useEffect } from 'react';
import { Text } from '@rneui/themed';
import { useContentQuery } from '@annunciate/query';
import { View } from '@annunciate/ui/dist/components/elements';
import { Content as BaseContent, } from '@annunciate/ui/dist/components/content/Content';
import { DiscussionChannelAware } from '@annunciate/comments';
export const Content = ({ contentId }) => {
    const { isPending, error, data, refetch } = useContentQuery(contentId);
    useEffect(() => {
        refetch();
    }, [contentId]);
    if (error)
        console.error(error);
    return (React.createElement(View, { style: { flexGrow: 1 } },
        React.createElement(React.Fragment, null,
            error && React.createElement(Text, null, "Error :("),
            React.createElement(BaseContent, { content: data?.Content, isLoading: isPending },
                React.createElement(DiscussionChannelAware, { id: data?.Content?.id, type: "content" })))));
};
//# sourceMappingURL=Content.js.map